"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isChainflexImportBusCable = exports.ChainflexImportBusCableSchema = void 0;
const zod_1 = require("zod");
const ChainflexImport_1 = require("./ChainflexImport");
const echain_prisma_client_1 = require("@igus/echain-prisma-client");
const echain_shared_i18n_1 = require("@igus/echain-shared-i18n");
exports.ChainflexImportBusCableSchema = ChainflexImport_1.ChainflexImportSchema.extend({
    categories: zod_1.z.custom((cats) => {
        if (!Array.isArray(cats))
            return false;
        return cats.includes(echain_prisma_client_1.ChainflexCategory.BusCables);
    }),
    busSystem: zod_1.z.custom(echain_shared_i18n_1.isLocalizedText, { message: 'invalid LocalizedText' }),
});
const isChainflexImportBusCable = (whatever) => {
    var _a;
    return (_a = exports.ChainflexImportBusCableSchema.safeParse(whatever)) === null || _a === void 0 ? void 0 : _a.success;
};
exports.isChainflexImportBusCable = isChainflexImportBusCable;
//# sourceMappingURL=ChainflexImportBusCable.js.map